import axiosInstance from 'integration/api/axiosInstance';
import {
  AbsenceCreationDto,
  AbsenceResponseDto,
  AbsenceUpdateDto,
  AbsenceUpdateResponseDto,
} from '@docbay/schemas';

export const AbsenceApi = {
  /**
   * @description This function creates an absence.
   * @param data - The absence creation data.
   * @returns A promise that resolves to the created absence response DTO.
   */
  createAbsence: (data: AbsenceCreationDto) =>
    axiosInstance.post('/professional-absences', data),

  /**
   * @description This function deletes an absence by ID.
   * @param id - The ID of the absence to be deleted.
   * @returns A promise that resolves when the absence is successfully deleted.
   */
  deleteAbsence: (id: string) =>
    axiosInstance.delete(`/professional-absences/${id}`),

  /**
   * @description This function retrieves an absence by ID.
   * @param id - The ID of the absence to be retrieved.
   * @returns A promise that resolves to the absence response DTO.
   */
  gteAbsenceById: (id: string) => {
    const params = {
      include: 'clinicProfessional,clinicProfessional.clinic.owner',
    };
    return axiosInstance.get<AbsenceResponseDto>(
      `/professional-absences/${id}`,
      { params },
    );
  },

  /**
   * @description This function updates an absence.
   * @param data - The absence update data.
   * @returns A promise that resolves to the updated absence response DTO.
   */
  updateAbsence: (data: AbsenceUpdateDto) => {
    return axiosInstance.patch<AbsenceUpdateResponseDto>(
      '/professional-absences',
      data,
    );
  },
};
